const PERMISSIONS = {
  CAN_VIEW_REQUESTS: 'view_requests',
  CAN_VIEW_USERS: 'view_users'
};
export default PERMISSIONS;
